import { generateDefaultViewItem } from '../../../ui-toolkit/cdItems/data/generateDefaultViewItem';
import { IBaseCDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/IBaseCDV3ViewItem';

export const createOnChangeHandlerGenerator =
  <TType extends IBaseCDV3ViewItem>(data: TType, onChangeCallback: (item: TType) => void) =>
  <TKey extends keyof TType>(name: TKey, transform: (v: any) => TType[TKey] | null = (x: any) => x) =>
  (value: any) =>
    onChangeCallback({ ...generateDefaultViewItem(), ...data, [name]: transform(value), dirty: true });
